// src/slices/FormDataSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface FormData {
  [key: string]: any;  // Can be more specific depending on the form structure
}

interface FormDataState {
  [key: string]: FormData;  // This stores the form data for each form (e.g., '1', '2', '3', ...)
}

const initialState: FormDataState = {
  '1': {},  // Client 1 Details
  '2': {},  // Client 2 Details
  '3': {},  // Dependents
  '4': {},  // Assets - Property
  '5': {},  // Assets - Non-Property
  '6': {},  // Assets - Vehicles
  '7': {},  // Liabilities
  '8': {},  // Expenses
};

const formDataSlice = createSlice({
  name: 'formData',
  initialState,
  reducers: {
    // Action to set or update form data for a specific form ID
    setFormsData: (
      state,
      action: PayloadAction<{ id: string; formData: FormData }>
    ) => {
      const { id, formData } = action.payload;

      // Update or set the form data for the given form ID
      state[id] = { ...state[id], ...formData };  // Merge new form data with the existing form data
    },
  },
});

export const { setFormsData } = formDataSlice.actions;

export default formDataSlice.reducer;
